export function getAuditSlugFromResponse(data) {
  if (!data) return null;
  const nested = data.data && typeof data.data === "object" ? data.data : null;
  return (
    data.slug ??
    nested?.slug ??
    data.share_slug ??
    nested?.share_slug ??
    data.shareSlug ??
    data.share_token ??
    data.shareToken ??
    null
  );
}

export function unwrapTestingToolApiPayload(data) {
  if (!data) return null;
  if (data.data && typeof data.data === "object" && !Array.isArray(data.data)) {
    return { ...data, ...data.data };
  }
  return data;
}

export function getDisplayIssues(payload) {
  if (!payload) return [];

  // Primary: new simplified backend returns issues directly under this key
  const issues = payload.issues ?? payload.issue_cards ?? payload.findings ?? [];
  if (Array.isArray(issues) && issues.length > 0) return issues;

  // Legacy fallbacks for records generated before the simplified pipeline
  const retrievedIssues = payload.retrievedIssues ?? payload.retrieved_issues ?? [];
  if (Array.isArray(retrievedIssues) && retrievedIssues.length > 0) return retrievedIssues;

  const deterministicIssues = payload.deterministicIssues ?? payload.deterministic_issues ?? [];
  if (Array.isArray(deterministicIssues) && deterministicIssues.length > 0) return deterministicIssues;

  const finalIssues = payload.finalIssues ?? payload.final_issues ?? [];
  return Array.isArray(finalIssues) ? finalIssues : [];
}

export function parseTestingToolReportResponse(data) {
  const payload = unwrapTestingToolApiPayload(data) ?? data ?? {};
  const report = payload?.report ?? payload?.summary ?? "";
  const metadata = payload?.metadata ?? {};
  const displayIssues = getDisplayIssues(payload);

  const usedMock = Boolean(payload?.usedMock);
  const model = payload?.model ?? "";

  let message = payload?.message;
  if (!message) {
    if (usedMock) {
      message = payload?.note ?? `Sample report${model ? ` (${model})` : ""}.`;
    } else {
      message = model ? `Live response via ${model}` : "Live response via Claude";
    }
  }

  return {
    report,
    retrievedIssues: displayIssues,
    metadata,
    siteType: metadata?.siteType ?? payload?.site_type ?? "",
    testTestingToolId:
      payload?.test_testing_tool_id ?? payload?.testTestingToolId ?? null,
    message,
    usedMock,
    model: payload?.model ?? null,
    totalOpenFindings: displayIssues.length,
    slug: getAuditSlugFromResponse(payload) ?? getAuditSlugFromResponse(data),
  };
}
